import { render, staticRenderFns } from "./PopUpItem.vue?vue&type=template&id=02657400"
import script from "./PopUpItem.vue?vue&type=script&lang=ts"
export * from "./PopUpItem.vue?vue&type=script&lang=ts"
import style0 from "./PopUpItem.vue?vue&type=style&index=0&id=02657400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports